import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Dinosaurs, software engineers, and cholera. What do they have in common?",
  "description": "",
  "date": "2019-02-25T08:00:00.000Z",
  "lastUpdated": "2019-02-25T08:00:00.000Z",
  "image": ""
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Imagine living in 1854 London.`}</p>
    <p>{`It's the center of the world. The richest city in the richest empire. Every day exciting new scientific, engineering, and medical discoveries. The age of enlightenment in full swing.`}</p>
    <p>{`People dress like this`}</p>
    <p><img parentName="p" {...{
        "src": "/ae357a34bef232d5a1fb4640ca479dd0/webimages-gallery_1850s_bowtie.gif",
        "alt": "A Victorian businessman"
      }}></img></p>
    <p>{`A Victorian businessman`}</p>
    <p>{`Very dashing.`}</p>
    <p>{`New railways all around you. Modern steam ships bring tea and spices from distant lands at unprecedented speeds. Never has life been so cushy. 🎩`}</p>
    <p>{`But London also smells bad.`}</p>
    <p>{`The streets are full of horse manure, the river Thames is filled with waste. You wear special shoe covers to keep shoes shiny while wading through mud and poop on your way to work.`}</p>
    <p>{`People getting sick from Cholera all around you. Thousands of people. Nobody knows why.`}</p>
    <p>{`Miasma is everyone's best bet. Invisible air particles.`}</p>
    <p>{`What else could it be? The air smells bad and people get sick. The worse the air smells the sicker they are. Right? Maybe it's all the smog ... or the poop? Maybe industrial waste evaporating from the river?`}</p>
    <p>{`You try to hold your breath.`}</p>
    <p>{`And then John Snow draws a map. A very important map.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/e91ce956f3c57d43b001d4cc2f4bfb16/0f98f/wikipedia-commons-thumb-2-27-Snow-cholera-map-1.jpg-1920px-Snow-cholera-map-1.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "93.72197309417041%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'375\\'%20viewBox=\\'0%200%20400%20375\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M381%204c-1%202-24%202-186%203C27%207%2010%207%2010%209a271056%20271056%200%2000-4%20359l85%201a652%20652%200%200196%200c-2-1-2-1%200-1l2%202%202%201c2%200%203%200%202-1l1-2%201%202a578%20578%200%2001102-2l91-1h8l-1-180a2842%202842%200%2000-3-183l-2%201c-1%202-1%202-2%200%200-2-6-3-7-1m-264%206c-11%200-11%201-9%205v2l-2-3-1-4H59c-43%200-46%200-46%202a340%20340%200%20001%2043h3c1%201%201%201-2%202h-3v9a5024%205024%200%2001-1%20127l-2%2074v16l3-2c4-3%205-3%205-2l-4%203-4%202v9l1%209v2l-1%209v9l-1%2022v22h82a751%20751%200%200095%200c10%200%2011%200%2010-2h1l6%202c5%200%206-1%204-3s-2-2%200-2l1-3%201-1v-1h1l1-1c-1-2%201-1%202%201%203%202%202%202%200%202h-1l-1%201v7h49a834%20834%200%200059-1l7-3%205-3%202-2h3c1%201%200%202-4%203-9%204-9%205-2%205l8-1h2l27%201h27l1-4v-8l-1-24-1-19-4%202-4%202v-1l5-3c3-2%204-2%204-8%200-4%200-6-1-5s-1%201-2-2l-2-4%202%202c1%203%201%203%202%201a78%2078%200%20000-25c1%201%201-15%201-68a170953%20170953%200%2001-1-187V9h-30l-31%201h-1l-36-1h-37l1%203c1%203%200%206-1%203h-1l-2-2c-1-2%201-3%201-1%201%201%201%201%201-1s0-2-19-2h-18v2l2%204c0%202%200%202-2%202s-4-4-2-4l1-2c-1-2-3-2-13-2s-13%201-13%202c1%201%200%202-6%201l-5-2c-1-1-5-1-10%201l-2-1h-52m112%20159l-5%201c-3%200-3%200-1%201%201%202%201%202-4%204l-7%203-2%202h7l4%205c2%206%203%206%205%205%201-1%201-2-1-6-3-6-4-7-1-7%202%200%203-2%202-4%200-1%201-2%203-2l3-3-3%201m51%2037v2c1%201-1%203-4%204l-4%203%208-3h2v2c-3%200-7%204-5%204l7-3c0-2%203%200%203%202%201%202%206%205%207%205l-2-4-4-5c0-1-1-3-3-3l-3-4%201-1c0-2-2-1-3%201M153%20319l-7%202-5%201h-2c-3%200-3%200-1%201h-2c-3%200-4%200-3%201s0%201-3%201l-5%201h-1l-5%202-5%203c-1%200-8%205-7%206l11-6%203-2c3-2%203-2%205%200l2%201h2c3%201%204%200%204-1h-2l-2-1%205-1c2%200%203%200%202-1h3c2%200%202%200%201-1s-1-1%201-1h5c3%200%203%200%202-1-3-1%205-3%209-3h1c-1%200-1-1%201-2%204-2%200-1-7%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/e91ce956f3c57d43b001d4cc2f4bfb16/ca0a1/wikipedia-commons-thumb-2-27-Snow-cholera-map-1.jpg-1920px-Snow-cholera-map-1.webp 223w", "/static/e91ce956f3c57d43b001d4cc2f4bfb16/75680/wikipedia-commons-thumb-2-27-Snow-cholera-map-1.jpg-1920px-Snow-cholera-map-1.webp 445w", "/static/e91ce956f3c57d43b001d4cc2f4bfb16/8d1ba/wikipedia-commons-thumb-2-27-Snow-cholera-map-1.jpg-1920px-Snow-cholera-map-1.webp 890w", "/static/e91ce956f3c57d43b001d4cc2f4bfb16/3838e/wikipedia-commons-thumb-2-27-Snow-cholera-map-1.jpg-1920px-Snow-cholera-map-1.webp 1335w", "/static/e91ce956f3c57d43b001d4cc2f4bfb16/e11e5/wikipedia-commons-thumb-2-27-Snow-cholera-map-1.jpg-1920px-Snow-cholera-map-1.webp 1780w", "/static/e91ce956f3c57d43b001d4cc2f4bfb16/882b9/wikipedia-commons-thumb-2-27-Snow-cholera-map-1.jpg-1920px-Snow-cholera-map-1.webp 1920w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/e91ce956f3c57d43b001d4cc2f4bfb16/853b2/wikipedia-commons-thumb-2-27-Snow-cholera-map-1.jpg-1920px-Snow-cholera-map-1.jpg 223w", "/static/e91ce956f3c57d43b001d4cc2f4bfb16/0a4fe/wikipedia-commons-thumb-2-27-Snow-cholera-map-1.jpg-1920px-Snow-cholera-map-1.jpg 445w", "/static/e91ce956f3c57d43b001d4cc2f4bfb16/7f80b/wikipedia-commons-thumb-2-27-Snow-cholera-map-1.jpg-1920px-Snow-cholera-map-1.jpg 890w", "/static/e91ce956f3c57d43b001d4cc2f4bfb16/dc6ba/wikipedia-commons-thumb-2-27-Snow-cholera-map-1.jpg-1920px-Snow-cholera-map-1.jpg 1335w", "/static/e91ce956f3c57d43b001d4cc2f4bfb16/2d2e5/wikipedia-commons-thumb-2-27-Snow-cholera-map-1.jpg-1920px-Snow-cholera-map-1.jpg 1780w", "/static/e91ce956f3c57d43b001d4cc2f4bfb16/0f98f/wikipedia-commons-thumb-2-27-Snow-cholera-map-1.jpg-1920px-Snow-cholera-map-1.jpg 1920w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/jpeg"
              }}></source>{`
        `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/e91ce956f3c57d43b001d4cc2f4bfb16/7f80b/wikipedia-commons-thumb-2-27-Snow-cholera-map-1.jpg-1920px-Snow-cholera-map-1.jpg",
                "alt": "John Snow's Map",
                "title": "John Snow's Map",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
      `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`John Snow's Map`}</figcaption>{`
  `}</figure></p>
    <p>{`John Snow's Map`}</p>
    <p>{`John Snow was studying Cholera outbreaks to figure out how they work. He had a bright idea: `}<em parentName="p">{`"What if I take a map and draw a line for every person sick from Cholera?"`}</em></p>
    <p>{`It worked.`}</p>
    <p>{`John looked at the map and realized these cases weren't random at all! They happen around a single water pump on Broad Street.`}</p>
    <p>{`616 cases and the closer you get to the pump, the more common they become.`}</p>
    <p><em parentName="p">{`"IT MUST BE THE WATER! Cholera spreads through bad water!!"`}</em>{` I bet he was excited.`}</p>
    <p>{`Epidemiology was born. It would take another 26 years before everyone agreed that germs exist.`}</p>
    <p>{`An early win for data visualization 💪`}</p>
    <h2 {...{
      "id": "engineers-and-developers"
    }}>{`Engineers and developers`}</h2>
    <p>{`Software engineers, software developers, and programmers have the same job right?`}</p>
    <p>{`They solve business problems with code and systems.`}</p>
    <p>{`You come to them with an idea, a business problem, or a feature request. They figure out how to build it, how to make sure it works, how it fits into existing systems, and build a solution.`}</p>
    <p>{`You probably do that all the time.`}</p>
    <p>{`But did you know engineers make almost `}{`\\`}{`\\`}{`\\$30,000/year more than programmers? 🤨`}</p>
    <p>{`It's true, I was just as surprised as you are.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/786171463732563968"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "480px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "105.82959641255604%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'424\\'%20viewBox=\\'0%200%20400%20424\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M29%2023c-4%204-4%204-4%2011l1%207%201%202c0%201%206%205%2011%206%203%200%205%200%208-2%205-2%205-4%201-4l-3-2c0-2%202-4%205-4l2-1%202-1c3%200%200-9-5-13-7-5-14-4-19%201m6%2085c0%206%202%207%202%201%201-5%204-6%204-1s7%207%209%202c1-5-4-9-8-6h-1l-3-1c-3%200-3%200-3%205m-10%2019v6h3c5%200%208-2%208-6%200-5-3-7-8-7h-3v7m1%2054l-1%206v6h9v-5l-1-7h-7m1%2037l-1%2010c0%2011%200%2011%2010%2011s10%200%2010-12v-9l-10-1-9%201m26%2057c-2%202-1%2018%200%2020l11%201h10v-6c0-5%200-6-2-6s-2-1-2-5v-4l-8-1-9%201m1%2010l1%2010h14v-19H54v9m86%2081c-5%205-2%2012%205%2012s10-9%204-13c-3-3-6-3-9%201m19%200c-3%203-4%206-1%2010%202%203%207%203%207%200h1c1%202%203%200%203-2s0-2-1-1c-1%202-2%201-3-2-1-4%200-5%201-3%202%203%203%202%203%200%200-4-6-6-10-2m90%200l-3%205c0%203%204%207%208%207%207%200%2010-8%205-13-4-3-7-3-10%201m18%200c-5%205-2%2012%206%2012%207%200%209-10%202-14-3-2-5-1-8%202m-73%200c-6%208%204%2017%2011%209%203-3%203-6-1-9-3-3-8-3-10%200m20%200c-5%202-4%208%201%2011%205%202%208%200%209-6%200-6-4-9-10-5m18-1c-1%202-1%204%201%206%201%202%201%204-1%204l-1-2-1-2c-2%200-1%204%201%205%202%202%209%203%2010%201l-2-2-1-5c1-5-3-8-6-5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/c341a929c453454652b7e21354e666f4/ca0a1/techletter.app-screenshot-1551110935347.webp 223w", "/static/c341a929c453454652b7e21354e666f4/75680/techletter.app-screenshot-1551110935347.webp 445w", "/static/c341a929c453454652b7e21354e666f4/d3be9/techletter.app-screenshot-1551110935347.webp 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/webp"
              }}></source>{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/c341a929c453454652b7e21354e666f4/e92b6/techletter.app-screenshot-1551110935347.png 223w", "/static/c341a929c453454652b7e21354e666f4/e66bf/techletter.app-screenshot-1551110935347.png 445w", "/static/c341a929c453454652b7e21354e666f4/e85cb/techletter.app-screenshot-1551110935347.png 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/png"
              }}></source>{`
        `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c341a929c453454652b7e21354e666f4/e85cb/techletter.app-screenshot-1551110935347.png",
                "alt": "https://twitter.com/Swizec/status/786171463732563968",
                "title": "https://twitter.com/Swizec/status/786171463732563968",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
      `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`https://twitter.com/Swizec/status/786171463732563968`}</figcaption>{`
  `}</figure></a></p>
    <p>{`I was looking into US visas a few years ago and realized that the H1B process creates a public dataset of salaries. When companies apply for your visa, they have to add salary info. It's one of the criteria.`}</p>
    <p>{`The government announces results publicly. 🤔`}</p>
    <p>{`So I took the 177,826 software jobs I could find and visualized them on a graph. Filtered by job title, state, and year. The results were shocking`}</p>
    <p><img parentName="p" {...{
        "src": "/92f742c633c55092302c282cb83e2958/static-salaries.92f742c6.gif",
        "alt": null
      }}></img></p>
    <p>{`Not only do engineers average almost `}{`\\`}{`\\`}{`\\$30,000/year more than programmers, everyone who codes makes more than an entire median household in their area. 🤯`}</p>
    <p>{`wow`}</p>
    <p>{`Think about that next time you call yourself a programmer ;)`}</p>
    <h2 {...{
      "id": "dinosaurs"
    }}>{`Dinosaurs`}</h2>
    <p>{`Say you're a scientist, a data scientist maybe, and you need a concise way to talk about a dataset. What do you do?`}</p>
    <p>{`Summary statistics is what you do. Mean, standard deviation, correlation. ✌️`}</p>
    <p>{`The mean tells you what an average datapoint looks like.`}</p>
    <p>{`Standard deviation tells you how close to the mean most values lie. John Snow's map is one big standard deviation example.`}</p>
    <p>{`Correlation tells you how much one variable affects another. If you change X, how much does Y change?`}</p>
    <p>{`But what if vastly different datasets had the same summary statistics?`}</p>
    <p>{`That's what Matejka and Fitzmaurice of Autodesk set out to discover in their research. They came up with this 👇`}</p>
    <p><img parentName="p" {...{
        "src": "/276ab6ca11c114964e00df8c2f35c69d/static-datasaurus.276ab6ca.gif",
        "alt": null
      }}></img></p>
    <p>{`12 datasets, 12 pictures, 1 set of stats. One version even renders as a dinosaur!`}</p>
    <p>{`And that's why you have to visualize your data to really understand what's going. Want to understand dinosaurs, engineers, or cholera? Gotta draw it out.`}</p>
    <p><img parentName="p" {...{
        "src": "/26bcf6c6d8a398f4cc93fd9333bcb951/media-AbPNdmgk6TJK-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`So tell me what's a time you were surprised by data? `}<a parentName="p" {...{
        "href": "https://twitter.com/Swizec"
      }}>{`Tweet me`}</a></p>
    <p>{`PS: did you know you're more likely to get hit by lighting thrice in the same year than to pick the perfect march madness bracket? Stats are weird`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      